import React, { useEffect, useState } from 'react';
import { PageHeader, PageLoader, EmptyState } from '@/components/common/Layout';
import { Card } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Badge } from '@/components/ui/badge';
import { api } from '@/lib/api';
import { fmtDate } from '@/lib/format';

export default function AuditPage() {
  const [items, setItems] = useState(null);
  const [q, setQ] = useState('');

  useEffect(() => { api.get('/audit', { params: { limit: 300 } }).then(r => setItems(r.data)); }, []);

  const filtered = (items || []).filter(a => !q || (a.activity + (a.user_email || '') + (a.resource_id || '')).toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="p-6 max-w-[1400px] mx-auto">
      <PageHeader title="Audit trail" subtitle="Immutable record of every mutation across the platform." />
      <Card className="p-3 mb-4">
        <Input placeholder="Search activity, user, resource…" value={q} onChange={e => setQ(e.target.value)} className="max-w-md" data-testid="audit-search" />
      </Card>
      {!items ? <PageLoader /> : filtered.length === 0 ? <EmptyState title="No audit entries" /> : (
        <Card className="p-0 divide-y divide-border">
          {filtered.map(a => (
            <div key={a.id} className="grid grid-cols-12 gap-3 p-3 text-xs items-center hover:bg-secondary/50" data-testid={`audit-row-${a.id}`}>
              <div className="col-span-3 font-mono text-muted-foreground">{fmtDate(a.created_at)}</div>
              <div className="col-span-3"><Badge variant="outline" className="text-[10px]">{a.activity}</Badge></div>
              <div className="col-span-3 truncate">{a.user_email || a.user_id || 'system'}</div>
              <div className="col-span-2 truncate">{a.resource_type || ''} {a.resource_id ? `· ${a.resource_id.slice(0,8)}` : ''}</div>
              <div className="col-span-1 text-right"><Badge variant={a.outcome === 'success' ? 'default' : 'destructive'} className="text-[10px]">{a.outcome}</Badge></div>
            </div>
          ))}
        </Card>
      )}
    </div>
  );
}
